import './Hud.css'
import SimulationTimeframe from './contact/SimulationTimeframe'
import CesiumContainer from './cesium/CesiumContainer';
import useScenario from '../../../hooks/useScenario';
import { useMemo } from 'react';
import { SCENARIO_DEPLOYMENT_TYPES } from '../../../../simulate/constants';

const Hud = () => {
    const { scenario } = useScenario()

    const scenarioType = useMemo(() => scenario?.scenarioDeploymentType, [scenario?.scenarioDeploymentType])
    const isQuickDeploy = useMemo(() => scenarioType === SCENARIO_DEPLOYMENT_TYPES.QUICK_DEPLOY, [scenarioType])
    return (
        <div className='hud__container'>
            <CesiumContainer />
            {!isQuickDeploy && <SimulationTimeframe />}
        </div>
    )
}

export default Hud